<template>
  <header class="header">
    <div class="header__mainLogo">
      <a href="https://platincoin.com" class="header__link">
        <logo-plc class="logoPlc" />
      </a>
    </div>
    <div class="header__main">
      <router-link to="/">
        <logo-explorer class="logoExplorer" />
      </router-link>
    </div>
    <span class="header__offline">OFFLINE</span>
    <header-search class="header__search" />
  </header>
</template>

<script>
import HeaderSearch from './components/HeaderSearch/index'
import logoPlc from '@/assets/img/logos/logo-plc.svg?inline'
import logoExplorer from '@/assets/img/logos/logo-explorer.svg?inline'

export default {
  name: 'Header',
  components: { HeaderSearch, logoPlc, logoExplorer },
}
</script>

<style>
.header__offline {
  color: #121212;
  font-weight: bold;
  align-self: center;
}
body.offline .header__offline {
  color: #ffff00;
}
</style>
<style lang="scss" scoped>
.header {
  background-color: $color-black;
  display: flex;
  height: var(--header-height);
  z-index: 11; // for GlNotification

  &__mainLogo,
  &__main,
  &__menuBtn {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  &__mainLogo {
    align-items: center;
    border-right: $border;
    display: flex;
    padding: 0 12px;

    @media (min-width: $breakpoint-xl) {
      padding: 0 16px;
    }
  }

  &__link {
    display: flex;
  }

  &__main {
    flex-grow: 1;

    @media (min-width: $breakpoint-md) {
      flex-grow: 0;
      padding: 0 16px;
    }
  }

  &__search {
    align-self: center;
    padding: 0 12px;

    @media (min-width: $breakpoint-md) {
      margin-left: auto;
      margin-right: 0;
    }

    @media (min-width: $breakpoint-lg) {
      padding: 0 16px;
      width: 50%;
    }

    @media (min-width: $breakpoint-xl) {
      padding: 0 32px;
      width: 33.33%;
    }
  }
}

.logoExplorer {
  height: 24px;
  width: 120px;

  @media (min-width: $breakpoint-lg) {
    height: 40px;
    width: 200px;
  }
}

.logoPlc {
  height: 24px;
  width: 24px;

  @media (min-width: $breakpoint-lg) {
    height: 40px;
    width: 40px;
  }
}
</style>
